import { render, staticRenderFns } from "./DirectRegistrationModal.vue?vue&type=template&id=3769c35e"
import script from "./DirectRegistrationModal.vue?vue&type=script&lang=ts"
export * from "./DirectRegistrationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports